export const AboutObj = {
  id: "about",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "About Me",
  headLine: "Turning Ideas Into High-Quality Web Experiences",
  description:
    "I’m Fred Vuni, with 5+ years of experience building scalable, user-focused web applications. I create web solutions that are visually appealing, highly functional, and tailored to your needs — from e-commerce platforms and on-demand services to portfolio showcases and custom web apps.",
  buttonLabel: "Get in Touch",
  imgStart: true,
  img: require("../../images/office.svg").default,
  alt: "office illustration",
  dark: false,
  primary: false,
  darkText: true,
};
